import Api from './api';


export const GetAllGroups = async () => {
  let data = []
  await Api.get('/groups')
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    });
  return data
}